import { Component, HostListener, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { EventHelper } from '@core/helpers/event.helper';
import { DepartmentPickerItem } from '@data-managment/department-picker/shared/department-picker-item';
import { TreeCellDropdownService } from './tree-cell-dropdown.service';

@Component({
  selector: 'pop-tree-cell-dropdown',
  templateUrl: './tree-cell-dropdown.component.html',
  styleUrls: ['./tree-cell-dropdown.component.less']
})
export class TreeCellDropdownComponent extends BaseComponent implements OnInit {
  @Input() title = 'MODAL.LINK_DEPARTMENT';
  @Input() actionLabel = 'BUTTON.ADD';
  @Input() includeShowAll = true;

  public x: number;
  public y: number;

  public readonly bottomOffset = 150;
  public readonly modalHeight = 110;

  public isOpen: boolean;

  public showAllDepartments = false;
  public showAllDepartmentsDisabled = false;

  public selectedDepartment: DepartmentPickerItem | undefined = undefined;
  public filteredDepartmentCodes: string[] = [];

  public constructor(private treeCellDropdownService: TreeCellDropdownService) {
    super();
  }

  public ngOnInit(): void {
    this.subscribe(
      this.treeCellDropdownService.observeDropdown().subscribe(state => {
        this.x = state.x;
        this.y = window.innerHeight - state.y < this.bottomOffset ? state.y - this.modalHeight : state.y; // displays the modal upward if its too close to the page bottom
        this.filteredDepartmentCodes = state.filteredDepartmentCodes;

        if (this.includeShowAll) {
          this.showAllDepartmentsDisabled = this.filteredDepartmentCodes.length === 0;
          if (this.filteredDepartmentCodes.length === 0) {
            this.showAllDepartments = true;
          }
        } else {
          this.showAllDepartments = false;
        }

        this.isOpen = true;
      })
    );
  }

  @HostListener('click')
  public backgroundClick() {
    this.exit();
  }

  @HostListener('window:keydown', ['$event'])
  public handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.exit();
      EventHelper.stopEventHere(event);
    }
    if (event.key === 'Enter') {
      this.selectDepartment();
      EventHelper.stopEventHere(event);
    }
  }

  private exit() {
    this.selectedDepartment = undefined;
    this.selectDepartment();
  }

  // Stop background click
  public click(e: MouseEvent) {
    EventHelper.stopEventHere(e);
  }

  public selectDepartment() {
    this.isOpen = false;
    this.treeCellDropdownService.selectDepartment(this.selectedDepartment);
  }

  public filterDepartments = ((d: DepartmentPickerItem) => {
    return this.filteredDepartmentCodes.includes(d.code);
  }).bind(this); // this is passed by reference. Bind is used to maintain the value of the keyword this
}
